import util from '../util'

let controller = 'PagadorEletronico'
export default {
  Obter: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  ObterBoletos: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Boletos', dto)
  },
  ExcluirBoleto: function (codigoConta, codigoBoleto) {
    return util.Axios.Delete(controller + '/Boleto/' + codigoConta, codigoBoleto)
  },
  Aderir: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  CancelarAdesao: function (codigoConta) {
    return util.Axios.Delete(controller, codigoConta)
  },
  ContestarBoleto: function (codigo) {
    return util.Axios.Post(controller + `/Aceite/Contestar/${codigo}`)
  }
}